import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {TooltipConfigModel, TooltipContentModel} from "@models/tooltip-content-model";

@Injectable({
  providedIn: 'root',
})
export class TooltipService {

  tooltipConfig = new BehaviorSubject<TooltipConfigModel>({
    arrowPosition: '50%'
  });

  displayTooltip = new BehaviorSubject<boolean>(false);
  clearOverflow = new BehaviorSubject<boolean>(false);
  tooltipWidth = new Subject<number>();
  tooltipHeight = new Subject<number>();
  tooltipContent = new Subject<TooltipContentModel>();


  showTooltip() {
    this.displayTooltip.next(true);
  }

  hideTooltip(clearOverflow: boolean = false, reset: boolean = false) {
    if (clearOverflow) {
      this.clearOverflow.next(clearOverflow)
    }
    if (this.displayTooltip.value) {
      this.displayTooltip.next(false);
      this.clearOverflow.next(false)
      if (reset) {
        this.tooltipConfig.next({
          arrowPosition: '50%'
        })
        this.tooltipContent.next({})
      }

    }
  }

  setTooltipConfig(config: TooltipConfigModel) {
   this.tooltipConfig.next({
      ...this.tooltipConfig.value,
      ...config,
    });
  }

  setTooltipContent(content: TooltipContentModel) {
    this.tooltipContent.next(content);
  }

  setTooltipHeight(height: number) {
    this.tooltipHeight.next(height);
  }

  setTooltipWidth(width: number) {
    this.tooltipWidth.next(width);
  }
}
